import * as Types from '@proxyqb/graphql-api-types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const LevelDetailFragmentDoc = gql`
    fragment LevelDetail on Level {
  id
  rev
  name
  taskDescription {
    local
  }
  renderCubes
  shuffleQuaternion {
    x
    y
    z
    w
  }
  allowedRotationDeviation
  stageGenerator {
    ... on SimpleStageGenerator {
      id
      goal {
        ... on TimeLevelGoal {
          hideAfter
          time
        }
        ... on StageCountLevelGoal {
          count
          hideAfter
        }
      }
      matchCubeGeometry
    }
    ... on SwitchedAssetsGenerator {
      id
      goal {
        ... on TimeLevelGoal {
          hideAfter
          time
        }
        ... on StageCountLevelGoal {
          count
          hideAfter
        }
      }
      goalPatterns {
        cubePattern
        goalPattern
        matchBy
      }
      matchCubeGeometry
      syncMatchBy
    }
    ... on TextStageGenerator {
      id
      goal {
        ... on TimeLevelGoal {
          hideAfter
          time
        }
        ... on StageCountLevelGoal {
          count
          hideAfter
        }
      }
      textColor
    }
    ... on ImageWordGenerator {
      id
      goal {
        ... on TimeLevelGoal {
          hideAfter
          time
        }
        ... on StageCountLevelGoal {
          count
          hideAfter
        }
      }
      imageWordSelect
      letterPosition
      letterCount
    }
    ... on SocialGenerator {
      id
      goal {
        ... on TimeLevelGoal {
          hideAfter
          time
        }
        ... on StageCountLevelGoal {
          count
          hideAfter
        }
      }
      assignment
      solution
      maxOptions
    }
  }
  requiredCubes {
    pattern
  }
  successBarTime
  isDeleted
  countErrors
  errorCounter {
    millisecondsToConfirmNoMovement
  }
  voiceAssistant {
    isEnabled
    hideGoals
  }
  voiceSuccessStage
  goalDistribution
}
    `;
export const WordImageDetailFragmentDoc = gql`
    fragment WordImageDetail on WordImage {
  id
  assetUrl
  word {
    local
  }
}
    `;
export const SocialCognitionImageItemFragmentDoc = gql`
    fragment SocialCognitionImageItem on SocialCognitionImage {
  id
  text {
    local
  }
  assetUrl
  emotionChoices {
    emotion {
      text {
        local
      }
      code
      id
    }
    correct
  }
  type
}
    `;
export const GetLevelDocument = gql`
    query getLevel($id: ID!) {
  getLevel(id: $id) {
    ...LevelDetail
  }
}
    ${LevelDetailFragmentDoc}`;

export function useGetLevelQuery(options: Omit<Urql.UseQueryArgs<GetLevelQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLevelQuery, GetLevelQueryVariables>({ query: GetLevelDocument, ...options });
};
export const WordImagesDocument = gql`
    query wordImages {
  wordImages {
    nodes {
      ...WordImageDetail
    }
  }
}
    ${WordImageDetailFragmentDoc}`;

export function useWordImagesQuery(options?: Omit<Urql.UseQueryArgs<WordImagesQueryVariables>, 'query'>) {
  return Urql.useQuery<WordImagesQuery, WordImagesQueryVariables>({ query: WordImagesDocument, ...options });
};
export const SocialCognitionImagesDocument = gql`
    query socialCognitionImages {
  socialCognitionImages {
    nodes {
      ...SocialCognitionImageItem
    }
  }
}
    ${SocialCognitionImageItemFragmentDoc}`;

export function useSocialCognitionImagesQuery(options?: Omit<Urql.UseQueryArgs<SocialCognitionImagesQueryVariables>, 'query'>) {
  return Urql.useQuery<SocialCognitionImagesQuery, SocialCognitionImagesQueryVariables>({ query: SocialCognitionImagesDocument, ...options });
};
export type LevelDetailFragment = { __typename?: 'Level', id: string, rev: string, name: string, renderCubes: boolean, allowedRotationDeviation?: number | null, successBarTime: number, isDeleted?: boolean | null, countErrors?: boolean | null, voiceSuccessStage?: Types.VoiceSuccessStage | null, goalDistribution?: Types.GoalDistribution | null, taskDescription: { __typename?: 'LocalizedText', local: string }, shuffleQuaternion?: { __typename?: 'Quaternion', x?: number | null, y?: number | null, z?: number | null, w?: number | null } | null, stageGenerator: { __typename?: 'ImageWordGenerator', id: Types.StageGeneratorId, imageWordSelect: Types.ImageWordSelect, letterPosition: Types.LetterPosition, letterCount: any, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any } } | { __typename?: 'SimpleStageGenerator', id: Types.StageGeneratorId, matchCubeGeometry?: Types.CubeGeometry | null, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any } } | { __typename?: 'SocialGenerator', id: Types.StageGeneratorId, assignment: Types.Assignment, solution: Types.Solution, maxOptions: number, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any } } | { __typename?: 'SwitchedAssetsGenerator', id: Types.StageGeneratorId, matchCubeGeometry?: Types.CubeGeometry | null, syncMatchBy?: boolean | null, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any }, goalPatterns: Array<{ __typename?: 'GoalPattern', cubePattern?: Types.CubePatterns | null, goalPattern?: Types.CubePatterns | null, matchBy: Types.MatchCubesBy }> } | { __typename?: 'TextStageGenerator', id: Types.StageGeneratorId, textColor: Types.TextStageGeneratorTextColor, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any } }, requiredCubes: Array<{ __typename?: 'RequiredCube', pattern: Types.CubePatterns }>, errorCounter?: { __typename?: 'ErrorCounter', millisecondsToConfirmNoMovement?: number | null } | null, voiceAssistant: { __typename?: 'LevelVoiceAssistant', isEnabled: boolean, hideGoals: boolean } };

export type GetLevelQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetLevelQuery = { __typename?: 'Query', getLevel: { __typename?: 'Level', id: string, rev: string, name: string, renderCubes: boolean, allowedRotationDeviation?: number | null, successBarTime: number, isDeleted?: boolean | null, countErrors?: boolean | null, voiceSuccessStage?: Types.VoiceSuccessStage | null, goalDistribution?: Types.GoalDistribution | null, taskDescription: { __typename?: 'LocalizedText', local: string }, shuffleQuaternion?: { __typename?: 'Quaternion', x?: number | null, y?: number | null, z?: number | null, w?: number | null } | null, stageGenerator: { __typename?: 'ImageWordGenerator', id: Types.StageGeneratorId, imageWordSelect: Types.ImageWordSelect, letterPosition: Types.LetterPosition, letterCount: any, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any } } | { __typename?: 'SimpleStageGenerator', id: Types.StageGeneratorId, matchCubeGeometry?: Types.CubeGeometry | null, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any } } | { __typename?: 'SocialGenerator', id: Types.StageGeneratorId, assignment: Types.Assignment, solution: Types.Solution, maxOptions: number, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any } } | { __typename?: 'SwitchedAssetsGenerator', id: Types.StageGeneratorId, matchCubeGeometry?: Types.CubeGeometry | null, syncMatchBy?: boolean | null, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any }, goalPatterns: Array<{ __typename?: 'GoalPattern', cubePattern?: Types.CubePatterns | null, goalPattern?: Types.CubePatterns | null, matchBy: Types.MatchCubesBy }> } | { __typename?: 'TextStageGenerator', id: Types.StageGeneratorId, textColor: Types.TextStageGeneratorTextColor, goal: { __typename?: 'StageCountLevelGoal', count: any, hideAfter?: any | null } | { __typename?: 'TimeLevelGoal', hideAfter?: any | null, time: any } }, requiredCubes: Array<{ __typename?: 'RequiredCube', pattern: Types.CubePatterns }>, errorCounter?: { __typename?: 'ErrorCounter', millisecondsToConfirmNoMovement?: number | null } | null, voiceAssistant: { __typename?: 'LevelVoiceAssistant', isEnabled: boolean, hideGoals: boolean } } };

export type WordImageDetailFragment = { __typename?: 'WordImage', id: string, assetUrl: string, word: { __typename?: 'LocalizedText', local: string } };

export type WordImagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type WordImagesQuery = { __typename?: 'Query', wordImages: { __typename?: 'WordImageAggregations', nodes: Array<{ __typename?: 'WordImage', id: string, assetUrl: string, word: { __typename?: 'LocalizedText', local: string } }> } };

export type SocialCognitionImageItemFragment = { __typename?: 'SocialCognitionImage', id: string, assetUrl: string, type: Types.SocialCognitionImageType, text: { __typename?: 'LocalizedText', local: string }, emotionChoices: Array<{ __typename?: 'Emotion', correct: boolean, emotion: { __typename?: 'CatalogItem', code?: string | null, id: string, text: { __typename?: 'LocalizedText', local: string } } } | null> };

export type SocialCognitionImagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SocialCognitionImagesQuery = { __typename?: 'Query', socialCognitionImages: { __typename?: 'SocialCognitionImageAggregations', nodes: Array<{ __typename?: 'SocialCognitionImage', id: string, assetUrl: string, type: Types.SocialCognitionImageType, text: { __typename?: 'LocalizedText', local: string }, emotionChoices: Array<{ __typename?: 'Emotion', correct: boolean, emotion: { __typename?: 'CatalogItem', code?: string | null, id: string, text: { __typename?: 'LocalizedText', local: string } } } | null> }> } };
